import PropTypes from "prop-types";
import { useMemo } from "react";

// material-ui
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// project import
import useConfig from "hooks/useConfig";
import Palette from "./palette";
import Typography from "./typography";

export default function ThemeCustomization({ children }) {
  const { config } = useConfig();
  const { borderRadius, fontFamily } = config;

  const theme = useMemo(() => Palette(), []);

  const themeTypography = useMemo(
    () => Typography(fontFamily),
    [fontFamily]
  );

  const themes = useMemo(
    () =>
      createTheme({
        palette: theme.palette,
        typography: themeTypography,
        shape: { borderRadius },
      }),
    [theme, themeTypography, borderRadius]
  );

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={themes}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

ThemeCustomization.propTypes = {
  children: PropTypes.node,
};
